export const SAVE_SCHOOL_DATA = 'SAVE_School_Data';
export const REMOVE_CACHE_PAGE = 'Remove_Cache_Page';
export const CACHE_CURRENT_PAGE = 'Cache_Current_Page';
export const GET_POST_LIKE = 'GET_POST_LIKE';
export const UPDATE_POST_LIKE = 'UPDATE_POST_LIKE';
export const RECORD_ACTIVE_NUM = 'RECORD_ACTIVE_NUM';
